import axiosClient from "../../../../../../api/axiosClient";

export async function fetchItemLedger(filters) {

  const params = {
    material_type: filters.materialType,
    material_id: filters.materialId,
    warehouse_id: filters.warehouse || undefined,
    batch_no: filters.batch || undefined,
    from_date: filters.fromDate || undefined,
    to_date: filters.toDate || undefined
  };

  const res = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/item-ledger",
    { params }
  );

  return res.data.data;
}

export async function exportItemLedgerExcel(
  filters = {}
) {

  const params = {
    material_type: filters.materialType || undefined,
    material_id: filters.materialId || undefined,
    warehouse_id: filters.warehouseId || undefined,
    batch_no: filters.batch || undefined,
    from_date: filters.fromDate || undefined,
    to_date: filters.toDate || undefined
  };

  const response = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/item-ledger/excel",
    {
      params,
      responseType: "blob"
    }
  );

  return response.data;
}